import { render, staticRenderFns } from "./AgentCard.vue?vue&type=template&id=22fb180e&scoped=true&"
import script from "./AgentCard.vue?vue&type=script&lang=js&"
export * from "./AgentCard.vue?vue&type=script&lang=js&"
import style0 from "./AgentCard.vue?vue&type=style&index=0&id=22fb180e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fb180e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22fb180e')) {
      api.createRecord('22fb180e', component.options)
    } else {
      api.reload('22fb180e', component.options)
    }
    module.hot.accept("./AgentCard.vue?vue&type=template&id=22fb180e&scoped=true&", function () {
      api.rerender('22fb180e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/components/CardInfo/Agent/AgentCard.vue"
export default component.exports